import { render } from "./SelectSession.vue?vue&type=template&id=670da9fa"
import script from "./SelectSession.vue?vue&type=script&lang=js"
export * from "./SelectSession.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wesratcliff/Desktop/Projects/reporting/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__